/**
 * GR05 입고조회(전체) 화면이 쓰는 엔드포인트.
 *
 * 동작별 배선 (LOGISPRD-11235 기준표):
 * | 동작     | 2.0 API                            | 1.0 API           | 비고 |
 * |----------|------------------------------------|-------------------|------|
 * | 화면     | —                                  | —                 | FE 신규 페이지. 기존 gr05(iframe)는 유지 — ST07→ST11 선례 |
 * | 조회     | `POST /api/v1/get-all-inbounds`      | /api/grid/search  | LOGISPRD-9554. **서버 페이징**(page/size) |
 * | 다운로드 | `POST /api/v1/get-all-inbounds/excel`| ToolBar EXPORT    | LOGISPRD-9555. 서버 엑셀(77컬럼), 30,000행 상한 |
 *
 * ST11(재고현황(단가))과 달리 둘 다 **POST + 바디**다 — 쿼리스트링 조립 유틸(toRepeatQuery)이 필요 없다.
 */
export const ALL_INBOUNDS_URL = '/api/v1/get-all-inbounds'
export const ALL_INBOUNDS_EXCEL_URL = `${ALL_INBOUNDS_URL}/excel`
